// Import model
import { OtgMeasurement } from '../models/OtgMeasurement';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgMeasurement - handles JSON serialization and deserialization with type validation
 */
export class OtgMeasurementSerializer {
  /**
   * Deserializes a JSON string into a OtgMeasurement instance
   */
  static deserialize(json: string): OtgMeasurement {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgMeasurement instance
   */
  static fromObject(obj: any): OtgMeasurement {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgMeasurement');
    }


    const instance: OtgMeasurement = {
      uom: obj['uom'] as string | undefined,
      quantity: obj['quantity'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgMeasurement instances
   */
  static deserializeArray(json: string): OtgMeasurement[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgMeasurement instance to a JSON string
   */
  static serialize(instance: OtgMeasurement): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgMeasurement instance to a plain object
   */
  static toObject(instance: OtgMeasurement): any {
    return {
      'uom': instance.uom,
      'quantity': instance.quantity,
    };
  }

  /**
   * Serializes an array of OtgMeasurement instances to a JSON string
   */
  static serializeArray(instances: OtgMeasurement[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
